<template>
  <v-dialog
    v-model="dialog"
    max-width="90%"
    width="unset"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-title class="justify-center text-uppercase headline">
        {{ title }}
      </v-card-title>
      <v-card-text v-if="description">
        {{ description }}
      </v-card-text>
      <v-card-actions class="ant-dialog-actions-bg ant-border-top">
        <v-spacer />
        <v-btn
          :disabled="loading"
          color="error"
          small
          text
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="loading"
          color="primary"
          elevation="0"
          small
          @click="deleteAction"
        >
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    deleteAction() {
      this.$emit('deleteAction');
    },
  },
};
</script>

<style scoped></style>
